/**
 * Starts decorative videos when they scroll into view.
 *
 * The autoplay attribute alone is not enough: iOS refuses it in Low Power
 * Mode, and Safari will decline when preload="metadata" means nothing is
 * buffered yet. Calling play() at the moment the element is on screen gets
 * past both, and pausing it again off screen keeps it off the battery.
 *
 * muted and playsInline are set as properties rather than trusted from the
 * attributes, because a muted video is the only kind allowed to start itself.
 */
(() => {
  const videos = [...document.querySelectorAll('video[autoplay]')];
  if (!videos.length) return;

  const still = window.matchMedia('(prefers-reduced-motion: reduce)');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (still.matches) return;
        if (isIntersecting) {
          target.play().catch(() => {
            // Refused anyway: the poster frame stays, which is a fine resting
            // state for something decorative.
          });
        } else if (!target.paused) {
          target.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  videos.forEach((video) => {
    video.muted = true;
    video.playsInline = true;
    if (still.matches) {
      video.removeAttribute('autoplay');
      video.pause();
      return;
    }
    observer.observe(video);
  });
})();
